import { FC, memo } from "react";
import styles from "./BlogVideoEmbed.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

interface BlogVideoEmbedProps {
  src: string;
  title: string;
  styles?: string;
}

const BlogVideoEmbed: FC<BlogVideoEmbedProps> = ({ src, title, styles: customStyles }) => (
  <>
    {customStyles && <style dangerouslySetInnerHTML={{ __html: customStyles }} />}
    <div className={styles.videoContainer}>
      <iframe
        src={src}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        className={styles.videoIframe}
      />
    </div>
  </>
);

export default wrapperHOC(memo(BlogVideoEmbed), {
  componentName: "BlogVideoEmbed-Blog",
  showForChina: true,
});
